import { ComponentProps } from "react";
import classNames from "classnames";

import { Color } from "utils/theme";
import { opacity } from "utils/canvas";

export interface ButtonProps extends ComponentProps<"button"> {
  variant?:
    | "primary"
    | "secondary"
    | "outline"
    | "ghost"
    | "destructive"
    | "sidebar";
  size?:
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "icon"
    | "icon-md"
    | "icon-lg"
    | "icon-lg-rounded";
}

export const Button = ({
  variant = "primary",
  size = "md",
  className,
  ...props
}: ButtonProps) => {
  const style = {
    primary: {
      background: Color.Indigo[500],
      borderColor: Color.Indigo[400],
    },
    secondary: {
      background: Color.Primary[700],
      borderColor: opacity(Color.Primary[600], 0.6),
    },
    outline: {
      background: Color.Primary[900],
      borderColor: Color.Primary[700],
    },
    destructive: {
      background: Color.Rose[700],
      borderColor: Color.Rose[600],
    },
    ghost: {
      background: "transparent",
      borderColor: "transparent",
    },
    sidebar: {
      background: "transparent",
      borderColor: "transparent",
      color: Color.Primary[400],
    },
  };

  const sizeStyle = {
    xs: "h-8 min-h-8 px-2.5 text-xs font-medium rounded-md ",
    sm: "h-10 min-h-10 px-3 text-sm font-medium rounded-lg ",
    md: "h-12 min-h-12 px-4 text-base font-medium rounded-lg ",
    lg: "h-14 min-h-14 px-5 text-lg font-medium rounded-lg ",
    icon: "h-10 w-10 p-0 rounded-lg ",
    "icon-md": "h-12 w-12 p-0 rounded-xl",
    "icon-lg": "h-14 w-14 p-0 rounded-xl",
    "icon-lg-rounded": "h-14 w-14 p-0 rounded-full",
  };

  return (
    <button
      onPointerDown={(e) => {
        e.currentTarget.style.opacity = "0.6";
      }}
      onPointerUp={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
      onPointerLeave={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
      onPointerEnter={(e) => {
        e.currentTarget.style.opacity = "0.8";
      }}
      className={classNames(
        "whitespace-nowrap disabled:opacity-70 border flex items-center justify-center",
        sizeStyle[size ?? "md"],
        className
      )}
      style={style[variant ?? "primary"]}
      {...props}
    />
  );
};
